import type { ActiveTab, SyntaxTabsProps } from './types';

const TABS: { id: ActiveTab; label: string }[] = [
  { id: 'syntax', label: 'Syntax' },
  { id: 'duplicates', label: 'Duplicates' },
];

export const SyntaxTabs = ({ activeTab, onSelect }: SyntaxTabsProps) => (
  <div className="syntax-tabs">
    {TABS.map((tab) => (
      <button
        key={tab.id}
        className={`syntax-tab${activeTab === tab.id ? ' active' : ''}`}
        onClick={() => onSelect(tab.id)}
      >
        {tab.label}
      </button>
    ))}
  </div>
);
